import { AuthenticationService, HistoryService, HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { HttpResponse } from '@philips-internal/oswald-ui-core/lib/services/http-service';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';
import { Value } from '@philips-internal/oswald-ui-core';
import { Data } from '../interfaces/data';
import { APPLICATION_ROUTES } from '../constants/application-routes';

interface OAuthResponse {
  access_token: string;
  expires_in: number;
  refresh_expires: number;
  refresh_token: string;
  token_type: string;
}

export interface ParameterValue {
  description: string;
  value: any; //eslint-disable-line
}

class Audit {

  addRouteListener(): void {
    HistoryService.addListener((path: string) => {

      return this.routeChangeLog(path).then((response: HttpResponse): Promise<any> => { //eslint-disable-line
        if (!response) {
          return Promise.resolve();
        }
        const oAuth = response.body as OAuthResponse;
        return AuthenticationService.updateJWTToken(oAuth);
      });

    });
  }

  routeChangeLog(path: string): Promise<any> { //eslint-disable-line

    const routes = {
      [this.parseRoute(APPLICATION_ROUTES.HOME_DASHBOARD)]: 'Dashboard',
      [this.parseRoute(APPLICATION_ROUTES.PROFILE)]: 'Profile',
      [this.parseRoute(APPLICATION_ROUTES.EXAMS)]: 'Exam result',
      [this.parseRoute(APPLICATION_ROUTES.EXAM_DETAILS)]: 'NonLab exam details', //
      [this.parseRoute(APPLICATION_ROUTES.EXAM_LAB_DETAILS)]: 'Lab exam details', //
      [this.parseRoute(APPLICATION_ROUTES.NEW_APPOINTMENT_PATIENT)]: 'New appointment',
      [this.parseRoute(APPLICATION_ROUTES.PSEUDONYM_APPOINTMENT_FORM)]: 'Pseudonym appointment form',
      [this.parseRoute(APPLICATION_ROUTES.APPOINTMENTS)]: 'Appointments',
      [this.parseRoute(APPLICATION_ROUTES.PSEUDONYM_APPOINTMENTS)]: 'Pseudonym appointments',
      [this.parseRoute(APPLICATION_ROUTES.APPOINTMENT_DETAIL)]: 'Appointment details',
      [this.parseRoute(APPLICATION_ROUTES.PSEUDONYM_APPOINTMENT_DETAIL)]: 'Pseudonym appointment details',
    };

    const functionName = routes[this.parseCurrentRoute(path)];

    if (!functionName) {
      return Promise.resolve();
    }

    const body = {
      functionName,
      'refresh_token': AuthenticationService.getRefreshToken(),
      route: path,
    };

    return Audit.functionAccessLog(body);
  }

  static functionAccessLog(requestBody: Record<string, Value>): Promise<HttpResponse> {
    return HttpService.post(APPLICATION_ENDPOINTS.FUNCTION_ACESS_LOG, {}, { body: requestBody });
  }

  static filterExecutedLog(filterRecord: Data, recordCount: number): Promise<HttpResponse> {
    const data: ParameterValue[] = [];

    for (const description in filterRecord) {
      let value = filterRecord[description];
      if (typeof (value) === 'object') {
        //@ts-ignore
        value = value.key; //eslint-disable-line
      }
      data.push({ description, value });
    }

    const body = {
      parameterValues: data,
      recordCount,
      'refresh_token': AuthenticationService.getRefreshToken(),
    };

    return HttpService.post(APPLICATION_ENDPOINTS.FILTER_EXECUTED_LOG, {}, { body });
  }

  parseCurrentRoute(route: string): string {
    const regex = /\d+/g;
    return this.removeUrlParams(route.replace(regex, ''));
  }

  parseRoute(route: string): string {
    const regex = /:\w+/g;
    return this.removeUrlParams(route.replace(regex, ''));
  }

  removeUrlParams(route: string): string {
    const regex = /\?(.*)/g;
    return route.replace(regex, '');
  }
}

export default Audit;
